// ** React Imports
import { Link } from 'react-router-dom';

// ** Custom Components
import Avatar from '@components/avatar';

import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from 'reactstrap';
import { Edit2, FileText, MoreVertical, Trash2 } from 'react-feather';

// ** Renders Client Columns
const renderClient = (row) => {
  return (
    <Avatar
      initials
      className="me-1"
      color={'light-primary'}
      content={row.fullName || ''}
    />
  );
};

// ** Renders Gender Columns
const genders = { MALE: 'Masculino', FEMALE: 'Femenino', OTHER: 'Otro' };

const statusObj = {
  ACTIVE: 'light-success',
  INACTIVE: 'light-secondary'
};

const membershioObj = {
  FREE: 'light-warning',
  FREEMIUM: 'light-success',
  PREMIUM: 'light-primary'
};

export const columns = ({ handleRedirect, handleUpdate, handleDelete }) => [
  {
    name: 'Usuario',
    sortable: true,
    minWidth: '270px',
    sortField: 'fullName',
    selector: (row) => row.fullName,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        {renderClient(row)}
        <div className="d-flex flex-column">
          <Link
            to={`/users/view/${row._id}`}
            className="user_name text-truncate text-body"
          >
            <span className="fw-bolder">
              {row?.fullName || 'No completado'}
            </span>
          </Link>
          <small className="text-truncate text-muted mb-0">{row.email}</small>
        </div>
      </div>
    )
  },
  {
    name: 'TELEFÓNO',
    minWidth: '150px',
    sortable: true,
    sortField: 'phone',
    selector: (row) => row.phone,
    cell: (row) => <span className="text-capitalize">{row.phone}</span>
  },
  {
    name: 'PAÍS',
    minWidth: '150px',
    sortable: true,
    sortField: 'country',
    selector: (row) => row.country,
    cell: (row) => <span>{row.country}</span>
  },
  {
    name: 'GÉNERO',
    minWidth: '150px',
    sortable: true,
    sortField: 'gender',
    selector: (row) => row.gender,
    cell: (row) => <span>{row.gender ? genders[row.gender] : 'N/A'}</span>
  },
  {
    name: 'MEMBRESÍA',
    sortable: true,
    minWidth: '172px',
    sortField: 'membership',
    selector: (row) => row.membership,
    cell: (row) => (
      <Badge
        className="text-capitalize"
        color={membershioObj[row.membership]}
        pill
      >
        {row.membership}
      </Badge>
    )
  },
  {
    name: 'Estado',
    minWidth: '138px',
    sortable: true,
    sortField: 'status',
    selector: (row) => row.status,
    cell: (row) => (
      <Badge className="text-capitalize" color={statusObj[row.status]} pill>
        {row.status}
      </Badge>
    )
  },
  {
    name: '',
    minWidth: '50px',
    cell: (row) => (
      <div className="column-action">
        <UncontrolledDropdown>
          <DropdownToggle tag="div" className="btn btn-sm">
            <MoreVertical size={14} className="cursor-pointer" />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              tag="button"
              className="w-100"
              onClick={() => handleRedirect({ row })}
            // onClick={(e) => handleUpdate({ e, row })}
            >
              <FileText size={14} className="me-50" />
              <span className="align-middle">Detalles</span>
            </DropdownItem>
            <DropdownItem
              tag="button"
              className="w-100"
              onClick={() => handleUpdate({ row })}
            >
              <Edit2 size={14} className="me-50" />
              <span className="align-middle">Editar</span>
            </DropdownItem>
            <DropdownItem
              tag="button"
              className="w-100"
              onClick={() => handleDelete({ row })}
            >
              <Trash2 size={14} className="me-50" />
              <span className="align-middle">Eliminar</span>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    )
  }
];
